export default "__VITE_ASSET__BTHhXc3B__"